'use strict';

export default class Labels {
    constructor(dataLayer, config) {
        this.dataLayer = dataLayer;
        this.config = config;
        this.initialized = false;
        this.domElement = null;
        this["Get in contact"] = "Get in contact";
        this["What are you looking for"] = "What are you looking for?";
        this["Looking for product contacts"] = "Are you looking for product contacts?";
        this["Contact by product name"] = "Find contact by product name";
        this["Sample by product name"] = "Request a sample by product name";
        this["Contact by segment"] = "Find a contact by market segment";
        this["Product Search"] = "Search for a product instead";
        this["Form intro"] = "Please enter your contact information so we are able to process your request. Thank you for your interest.";
        this["Different contact"] = "Select a different contact";
        this["Ack1"] = "I allow Clariant to store and process my information for the purpose given in this contact form";
        this["Ack2"] = "I authorize Clariant to store my contact details and/or to contact me for marketing purposes";
        this["Other Contact"] = "General Contact";
        this["No products found"] = "No products matching your criteria were found";
        this["Submitting"] = "Your request is being submitted. Please wait a few moments.";
        this["Submitted"] = "Your request has been submitted successfully.";
        this["Restart"] = "Submit another request";
        this["Try again"] = "Review form information";
        this["Business Line Placeholder"] = "Market segment";
        this["Business Unit Placeholder"] = "Business unit";
        this["Product Search Placeholder"] = "Product";
        this["Request type"] = "Request type"
    }
    get(name) {
        if (this.hasOwnProperty(name)) return this[name];
        return `${name}`;
    }
    init(el) {
        if (el == null) return;
        this.domElement = el.parentNode;
        let self = this;
        this["Tile Pretitle"] = this.getStaticLabel("tilepretitle");
        this["Tile Title"] = this.getStaticLabel("tiletitle");
        this["Tile Description"] = this.getStaticLabel("tiledescription");
        this["Tile CTA"] = this.getStaticLabel("tilectalabel");
        return new Promise((resolve, reject) => {
            this.dataLayer.getLabels().then(res => {
                if (!res.data) reject({message: "Invalid response received from server when loading labels."});
                for (const key in res.data) {
                    if (res.data.hasOwnProperty(key)) {
                        self[key] = res.data[key];
                    }
                }
                resolve(self);
            }).catch(err => {
                reject(err);
            }).finally(() => {
                self.initialized = true;
            });
        });
    }
    getStaticLabel(name) {
        const parentElement = this.domElement || document;
        const label = parentElement.querySelector(`.labels > input[name='${name}']`);
        if (!label) return "";
        return label.value;
    }
};
